// extracted by mini-css-extract-plugin
export default {"sticky":"grid_styles_sticky__n9UqH"};